import { useNavigate } from 'react-router-dom';

export default function WhatIsSection() {
  const navigate = useNavigate();

  const benefits = [
    { icon: 'ri-time-line', title: 'Save Research Time', desc: 'Skip hours of manual searching with pre-organized spreadsheets that put the best finds right at your fingertips.' },
    { icon: 'ri-search-eye-line', title: 'Find Products Faster', desc: 'Browse curated product databases sorted by category, price range, and popularity for instant discovery.' },
    { icon: 'ri-scales-3-line', title: 'Compare Prices Easily', desc: 'Side-by-side price comparisons help you spot the best deals and avoid overpaying for any item.' },
    { icon: 'ri-ship-line', title: 'Understand Shipping Costs', desc: 'Detailed shipping breakdowns by weight, destination, and carrier so you never get surprised at checkout.' },
    { icon: 'ri-shield-check-line', title: 'Avoid Common Mistakes', desc: 'Learn from experienced users who share real stories about what works and what to watch out for.' },
    { icon: 'ri-database-2-line', title: 'Community-Powered Data', desc: 'Access crowd-sourced finds and reviews updated regularly by a passionate community of shoppers.' },
  ];

  return (
    <section id="what-is" className="py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-800 text-xs font-semibold tracking-wide uppercase mb-4">
            Getting Started
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            What Is <span className="italic text-primary-600">Basetao Spreadsheet</span>?
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-base leading-relaxed">
            Basetao Spreadsheet is a structured resource system that helps users discover products, compare options, organize purchases, and understand the complete shopping process — from browsing to delivery.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {benefits.map((item) => (
            <div
              key={item.title}
              className="group bg-background-100 rounded-xl p-6 border border-background-200/60 hover:border-primary-200/40 transition-all duration-300"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-foreground-600 text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <button
            onClick={() => navigate('/basetao-spreadsheet-guide')}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-semibold whitespace-nowrap cursor-pointer transition-all duration-200 bg-foreground-900 text-background-50 hover:bg-foreground-800"
          >
            Read the Complete Guide
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}